import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import TablaDetalle from './DetallePresupuesto';
import TablaDetalleMod from './DetallePresupuestoMod';
import TablaDetalleVer from './DetallePresupuestoVer';
import styled from 'styled-components';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import Swal from 'sweetalert2';

import {
    AsyncSelectField,
    renderField,
    renderCurrencyFloat,
    renderCurrencyFloatTC,
    renderNumber,
    SelectField
} from "../../Utils/renderField/renderField";

function PresupuestoForm(props) {
    const {
        modulo,
        listarProyectos,
        titulo,
        crear,
        editar,
        bloqueo,
        agregarLinea,
        registroPresupuesto,
        detalleOrden,
        detalleOrd,
        eliminarLinea,
        listarLineas,
        agregarLineaNueva,
        modificarPresupuesto,
        eliminarLineaGasto,
        buscarCliente,
        clienteProyecto,
        cambioD,
        tipoProyecto
    } = props;

    const estilo = {
        overflow: "auto",
        height: "200px",

    };
    const handleOnChangeProyecto = value => {
        buscarCliente(value.value);
    };
    const [tipoCambioD, setTipoCambioD] = useState(0.000000);
    const [montoD, setMontoD] = useState(0.000000);
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const tipo = [
        {
            value: 'LOC',
            label: 'LOCAL'
        },
        {
            value: 'EXP',
            label: 'EXTERIOR'
        },
    ];
    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        {crear === false && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-10'>
                                    <Field
                                        name="nombreProyecto"
                                        placeholder="Proyecto"
                                        className="form-control"
                                        component={renderField}
                                        disabled={true}
                                        msj="Proyecto"
                                    />
                                </div>
                            </div>
                        }
                        {crear === true && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-10'>
                                    <Field
                                        name="proyecto"
                                        placeholder="Proyecto..."
                                        className="form-control-find"
                                        onChange={handleOnChangeProyecto}
                                        component={AsyncSelectField}
                                        loadOptions={listarProyectos}
                                        msj="Proyecto"
                                    />
                                </div>
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-10'>
                                        <Field
                                            name="nombreCliente"
                                            placeholder="Cliente"
                                            className="form-control"
                                            component={renderField}
                                            disabled={true}
                                            msj="Cliente"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <Field
                                                name="tipo"
                                                options={tipo}
                                                dato={tipoProyecto}
                                                component={SelectField}
                                                className="form-select"
                                                disabled={true}
                                                msj="Tipo"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {crear === true && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-10'>
                                    <div className="form-floating">
                                        <input
                                            className = {classNames('form-control')}
                                            type="text"
                                            value = {clienteProyecto}
                                            disabled = {true}
                                        />
                                        <label className='form-label'>Cliente</label>
                                    </div>
                                </div>
                                <div className='col-2'>
                                    <div className="form-floating">
                                        <Field
                                            name="tipo"
                                            options={tipo}
                                            dato={tipoProyecto}
                                            component={SelectField}
                                            className="form-select"
                                            disabled={true}
                                            msj="Tipo"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {crear === false && editar === true &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-10'>
                                        <Field
                                            name="nombreProyecto"
                                            placeholder="Proyecto"
                                            className="form-control"
                                            component={renderField}
                                            disabled={true}
                                            msj="Proyecto"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-10'>
                                        <Field
                                            name="proyecto_mod"
                                            placeholder="Proyecto..."
                                            className="form-control-find"
                                            onChange={handleOnChangeProyecto}
                                            component={AsyncSelectField}
                                            loadOptions={listarProyectos}
                                            msj="Proyecto"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-10'>
                                        <Field
                                            name="nombreCliente"
                                            placeholder="Cliente"
                                            className="form-control"
                                            component={renderField}
                                            disabled={true}
                                            msj="Cliente"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {crear === true && editar === false &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="imprevistos"
                                            placeholder="Imprevistos"
                                            component={renderNumber}
                                            msj="Imprevistos (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="inflacion"
                                            placeholder="Inflación"
                                            component={renderNumber}
                                            msj="Inflación (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="utilidad"
                                            placeholder="Utilidad"
                                            component={renderNumber}
                                            msj="Utilidad (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="comision"
                                            placeholder="Comisión de ventas"
                                            component={renderNumber}
                                            msj="Comisión de ventas (%)"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="renta"
                                            placeholder="Renta"
                                            component={renderNumber}
                                            msj="Renta (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="retencion"
                                            placeholder="Retención"
                                            component={renderNumber}
                                            msj="Retención (%)"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_imprevistos"
                                            placeholder="Imprevistos"
                                            component={renderNumber}
                                            disabled={true}
                                            msj="Imprevistos (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_inflacion"
                                            placeholder="Inflación"
                                            component={renderNumber}
                                            disabled={true}
                                            msj="Inflación (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_utilidad"
                                            placeholder="Utilidad"
                                            component={renderNumber}
                                            disabled={true}
                                            msj="Utilidad (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_comision_ventas"
                                            placeholder="Comisión de ventas"
                                            component={renderNumber}
                                            disabled={true}
                                            msj="Comisión de ventas (%)"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_renta"
                                            placeholder="Renta"
                                            component={renderNumber}
                                            disabled={true}
                                            msj="Renta (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_retencion"
                                            placeholder="Retención"
                                            component={renderNumber}
                                            disabled={true}
                                            msj="Retención (%)"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {crear === false && editar === true &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_imprevistos"
                                            placeholder="Imprevistos"
                                            component={renderNumber}
                                            msj="Imprevistos (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_inflacion"
                                            placeholder="Inflación"
                                            component={renderNumber}
                                            msj="Inflación (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_utilidad"
                                            placeholder="Utilidad"
                                            component={renderNumber}
                                            msj="Utilidad (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_comision_ventas"
                                            placeholder="Comisión de ventas"
                                            component={renderNumber}
                                            msj="Comisión de ventas (%)"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_renta"
                                            placeholder="Renta"
                                            component={renderNumber}
                                            msj="Renta (%)"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="porcentaje_retencion"
                                            placeholder="Retención"
                                            component={renderNumber}
                                            msj="Retención (%)"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {crear === true && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-2'>
                                    <div className="form-floating">
                                        <NumberFormat
                                            className={classNames('form-control')}
                                            decimalScale={6}
                                            fixedDecimalScale
                                            placeholder="Tipo de cambio"
                                            value={tipoCambioD}
                                            thousandSeparator
                                            onValueChange={(values) => {
                                                setTipoCambioD(values.value)
                                            }}
                                        />
                                        <label className='form-label' htmlFor="cuenta">
                                            Tipo de cambio
                                        </label>
                                    </div>
                                </div>
                                {/*<div className='col-3 mt-2'>
                                    <button
                                        className='btn mr-2 mb-3 btn-secondary'
                                        onClick={() => {
                                            let tc = tipoCambio(fechaInicio, fechaFinal);
                                            tc.then(d => { 
                                                setTipoCambioD(d);
                                            });
                                            
                                        }}
                                    >
                                        Buscar tipo de cambio
                                    </button>
                                </div>**/}
                                <div className='col-2'>

                                </div>
                                
                            </div>
                        }
                        {(crear === false || editar == true) &&
                            <div className='row mb-2'>
                                <div className='col-3'>
                                    <Field
                                        name="numero"
                                        placeholder="Numero"
                                        className="form-control"
                                        component={renderField}
                                        disabled={true}
                                        msj="Numero"
                                    />
                                </div>
                                <div className='col-3'>
                                    <Field
                                        name="tipo_cambio"
                                        placeholder="Tipo cambio"
                                        component={renderCurrencyFloatTC}
                                        disabled={true}
                                        msj="Tipo cambio"
                                    />
                                </div>
                                <div className='col-3'>
                                    <Field
                                        name="total_quetzales"
                                        placeholder="Total (Q)"
                                        component={renderCurrencyFloat}
                                        disabled={true}
                                        msj="Total (Q)"
                                    />
                                </div>
                                <div className='col-3'>
                                    <Field
                                        name="total_dolares"
                                        placeholder="Total (USD)"
                                        component={renderCurrencyFloat}
                                        disabled={true}
                                        msj="Total (USD)"
                                    />
                                </div>
                            </div>
                        }
                        <div className='mb-2'>
                            <Field
                                name="observaciones"
                                placeholder="Observaciones"
                                component={renderField}
                                className="form-control"
                                disabled={bloqueo}
                                msj="Observaciones"
                            />
                        </div>
                        <h5 className="p-2 bg-secondary title mt-1">Detalle presupuesto</h5>
                        {crear === true &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-8'>
                                        <Field
                                            name="linea"
                                            placeholder="Linea presupuestaria..."
                                            className="form-control-find"
                                            component={AsyncSelectField}
                                            loadOptions={listarLineas}
                                            msj="Linea presupuestaria"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="monto_q"
                                            placeholder="Monto quetzales"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            msj="Monto quetzales"
                                            onChange={(e, value) => {
                                                if (tipoCambioD === 0 || tipoCambioD === 0.000000) {
                                                    Swal.fire({
                                                        title: 'Presupuesto',
                                                        text: 'Debe de ingresar tipo de cambio',
                                                        type: 'error',
                                                    })
                                                }else{
                                                    if (value) {
                                                        let totD = parseFloat(parseFloat(value) / parseFloat(tipoCambioD)).toFixed(2)
                                                        setMontoD(totD)
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Monto dólares"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={montoD}
                                                name="totalQ"
                                            />
                                            <label className='form-label' htmlFor="total">
                                            Monto dólares
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {editar === true &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-8'>
                                        <Field
                                            name="linea"
                                            placeholder="Linea presupuestaria..."
                                            className="form-control-find"
                                            component={AsyncSelectField}
                                            loadOptions={listarLineas}
                                            msj="Linea presupuestaria"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="monto_q"
                                            placeholder="Monto quetzales"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            msj="Monto quetzales"
                                            onChange={(e, value) => {
                                                if (cambioD === 0 || cambioD === 0.000000) {
                                                    Swal.fire({
                                                        title: 'Presupuesto',
                                                        text: 'Debe de ingresar tipo de cambio',
                                                        type: 'error',
                                                    })
                                                }else{
                                                    if (value) {
                                                        let totD = parseFloat(parseFloat(value) / parseFloat(cambioD)).toFixed(2)
                                                        setMontoD(totD)
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Monto dólares"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={montoD}
                                                name="totalQ"
                                            />
                                            <label className='form-label' htmlFor="total">
                                            Monto dólares
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {(crear === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => {
                                        setMontoD(0.00);
                                        agregarLinea(tipoCambioD);
                                    }}
                                >
                                    Agregar
                                </button>
                            </Contenido>
                        }
                        {(editar === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => {
                                        setMontoD(0.00);
                                        agregarLineaNueva(cambioD);
                                    }}
                                >
                                    Agregar
                                </button>
                            </Contenido>
                        }
                        {crear === true && editar === false &&
                            <div style={estilo}>
                                <TablaDetalle
                                    detalle={detalleOrden}
                                    eliminarLinea={eliminarLinea}
                                />
                            </div>
                        }
                        {crear === false && editar === true &&
                            <div style={estilo}>
                                <TablaDetalleMod
                                    detalle={detalleOrd}
                                    eliminarLineaGasto={eliminarLineaGasto}
                                />
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div style={estilo}>
                                <TablaDetalleVer
                                    detalle={detalleOrd}
                                />
                            </div>
                        }
                        <br />
                        <div className='d-flex flex-row mt-3'>
                            {crear === true && editar === false &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => registroPresupuesto(detalleOrden, tipoCambioD)}
                                >
                                    Guardar
                                </button>
                            }
                            {editar === true && crear === false &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => modificarPresupuesto(detalleOrden, tipoCambioD)}
                                >
                                    Modificar
                                </button>
                            }
                            <a
                                href={`/#/gestion_proyecto/${id_emp[5]}/presupuesto`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

PresupuestoForm.propTypes = {
    crear: PropTypes.bool,
};

export default reduxForm({
    form: 'FormPresupuesto',
})(PresupuestoForm);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;